import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface UsageStatisticsReferenceInput {
  userType: SystemCode
  counter: number
}

export function UsageStatisticsReferenceInputFromJSON(
  json: any
): UsageStatisticsReferenceInput {
  return {
    userType: exists(json, 'user_type')
      ? SystemCodeFromJSON(json.user_type)
      : defaultSystemCode(),
    counter: exists(json, 'counter') ? json.counter : 0
  }
}
